export default __webpack_public_path__ + "static/media/hero-cover.2b6c1eb3.png";